import { DeviceTimeSetting } from "./deviceTimeSetting";

export class DeviceSetting{
    id: number;
    value: string;
    times: Array<DeviceTimeSetting>
}

